<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3301 7.50792H11.3267C10.8542 7.50621 10.4725 7.12102 10.4742 6.64851L10.4793 5.35256C10.481 4.88091 10.8645 4.5 11.3353 4.5H11.3387C11.8112 4.50171 12.193 4.8869 12.1913 5.35941L12.1861 6.65536C12.1844 7.12701 11.8009 7.50792 11.3301 7.50792Z"
      fill="currentColor"
    />
    <path
      d="M9.64558 12.0883C9.42645 12.0883 9.20731 12.0044 9.0404 11.8375C8.70571 11.5028 8.70571 10.9609 9.0404 10.6271C9.37509 10.2933 9.00701 9.42617 8.8983 9.22929C8.66548 8.81756 8.81185 8.29713 9.22358 8.06516C9.6353 7.83233 10.1583 7.97956 10.3911 8.39129C10.8345 9.17622 11.3045 10.7846 10.2516 11.8383C10.0847 12.0052 9.86556 12.0891 9.64643 12.0891L9.64558 12.0883Z"
      fill="currentColor"
    />
    <path
      d="M12.8932 12.0883C12.674 12.0883 12.4549 12.0044 12.288 11.8375C11.9533 11.5028 11.9533 10.9609 12.288 10.6271C12.6227 10.2933 12.2546 9.42617 12.1459 9.22929C11.9131 8.81756 12.0594 8.29713 12.4712 8.06516C12.8829 7.83233 13.4059 7.97956 13.6387 8.39129C14.0821 9.17622 14.5521 10.7846 13.4992 11.8383C13.3323 12.0052 13.1132 12.0891 12.894 12.0891L12.8932 12.0883Z"
      fill="currentColor"
    />
    <path
      d="M5.50776 12.5359C5.92376 9.6958 8.37615 7.50791 11.3293 7.50791C13.7423 7.50791 15.8206 8.96822 16.7271 11.0517C16.8264 11.0457 16.9266 11.0414 17.0284 11.0414C17.5942 11.0414 18.1361 11.1416 18.6394 11.3247C17.7363 8.13791 14.8012 5.7968 11.3293 5.7968C7.14097 5.7968 3.73331 9.20447 3.73331 13.3928C3.73331 13.8653 4.11679 14.2488 4.58929 14.2488H12.5516C12.7716 13.6042 13.126 13.023 13.5822 12.5368H5.50776V12.5359Z"
      fill="currentColor"
    />
    <path
      d="M17.5283 20.4991C17.7329 20.4991 17.9263 20.4538 18.101 20.375C17.756 20.4555 17.3973 20.4991 17.0284 20.4991H17.5283Z"
      fill="currentColor"
    />
    <path
      d="M13.3896 18.7872H5.40418V18.3763C5.40418 17.6059 4.77761 16.9785 4.00637 16.9785H3.95329V16.8715L12.4318 16.8775C12.3462 16.5223 12.3 16.1516 12.3 15.7707C12.3 15.5653 12.3145 15.3641 12.3402 15.1655L3.64001 15.1595C3.2668 15.1595 2.91585 15.305 2.6522 15.5687C2.3877 15.8323 2.24219 16.1841 2.24219 16.5573V17.2935C2.24219 18.0639 2.86877 18.6913 3.64001 18.6913H3.69308V19.1022C3.69308 19.8726 4.32051 20.5 5.09089 20.5H17.0301C15.5681 20.5 14.2602 19.8332 13.3913 18.788L13.3896 18.7872Z"
      fill="currentColor"
    />
    <path
      d="M13.3169 16.8766H12.4318C12.6038 17.5888 12.936 18.2394 13.3905 18.7863H14.6017C13.9982 18.3001 13.5446 17.6376 13.3177 16.8766H13.3169Z"
      fill="currentColor"
    />
    <path
      d="M21.7577 15.7698C21.7577 13.7275 20.4566 11.9838 18.6402 11.3239C18.7352 11.6586 18.8071 12.0027 18.8551 12.3545C20.0731 13.0067 20.9017 14.2916 20.9017 15.7698C20.9017 16.482 20.7091 17.148 20.3736 17.7215C20.2726 18.0707 20.0398 18.3635 19.7325 18.5424C19.4911 18.7778 19.2197 18.9815 18.9236 19.1475C18.9056 19.6945 18.5735 20.1619 18.101 20.375C20.193 19.888 21.7577 18.0091 21.7577 15.7707V15.7698Z"
      fill="currentColor"
    />
    <path
      d="M13.4667 14.2479H12.5525C12.4523 14.5415 12.3804 14.848 12.3402 15.1647H13.203C13.2535 14.8445 13.3426 14.5372 13.4667 14.2479Z"
      fill="currentColor"
    />
    <path
      d="M16.7271 11.0517C15.4902 11.1296 14.3817 11.6851 13.5831 12.5359H14.8979C15.5065 12.1336 16.2358 11.8991 17.0199 11.8974C16.9437 11.6064 16.8461 11.3239 16.7271 11.0517Z"
      fill="currentColor"
    />
    <path
      d="M14.8979 12.5359H13.5831C13.1269 13.0221 12.7725 13.6034 12.5525 14.2479H13.4667C13.7671 13.546 14.2687 12.952 14.8987 12.5359H14.8979Z"
      fill="currentColor"
    />
    <path
      d="M16.7271 11.0517C16.8452 11.3239 16.9428 11.6064 17.0199 11.8974C17.0224 11.8974 17.0258 11.8974 17.0284 11.8974C17.6892 11.8974 18.3107 12.0634 18.8542 12.3545C18.8063 12.0027 18.7344 11.6586 18.6394 11.3239C18.1361 11.1407 17.5942 11.0405 17.0284 11.0405C16.9274 11.0405 16.8273 11.0448 16.7271 11.0508V11.0517Z"
      fill="currentColor"
    />
    <path
      d="M13.3169 16.8766C13.2124 16.5265 13.1551 16.155 13.1551 15.7698C13.1551 15.5644 13.1714 15.3624 13.2022 15.1647H12.3393C12.3137 15.3624 12.2991 15.5644 12.2991 15.7698C12.2991 16.1508 12.3453 16.5214 12.4309 16.8766H13.3169Z"
      fill="currentColor"
    />
    <path
      d="M18.9236 19.1475C18.3629 19.4626 17.7175 19.6432 17.0284 19.6432C16.1091 19.6432 15.2651 19.3222 14.6009 18.7872H13.3896C14.2576 19.8323 15.5664 20.4991 17.0284 20.4991C17.3973 20.4991 17.756 20.4555 18.101 20.375C18.5735 20.1619 18.9056 19.6945 18.9236 19.1475Z"
      fill="currentColor"
    />
    <path
      d="M19.7316 18.5415C20.0389 18.3626 20.2726 18.0699 20.3727 17.7206C20.1964 18.0228 19.9798 18.2984 19.7316 18.5415Z"
      fill="currentColor"
    />
    <path
      d="M14.4254 14.2479H13.4667C13.3426 14.5372 13.2535 14.8445 13.203 15.1655H14.0727C14.1395 14.8377 14.261 14.5287 14.4254 14.2479Z"
      fill="currentColor"
    />
    <path
      d="M17.0199 11.8974C16.2358 11.8991 15.5073 12.1345 14.8979 12.5359H17.1517C17.12 12.3185 17.0746 12.1062 17.0199 11.8974Z"
      fill="currentColor"
    />
    <path
      d="M18.9244 13.4253C19.5673 13.9457 19.9927 14.7247 20.0406 15.6021C20.2803 15.8529 20.4292 16.1927 20.4292 16.5668V17.3346C20.4292 17.469 20.4095 17.5982 20.3736 17.7215C20.7083 17.148 20.9017 16.482 20.9017 15.7698C20.9017 14.2916 20.0731 13.0067 18.8551 12.3545C18.9013 12.6943 18.9261 13.0401 18.9261 13.3919C18.9261 13.4031 18.9253 13.4142 18.9244 13.4253Z"
      fill="currentColor"
    />
    <path
      d="M18.9261 18.7315V19.1005C18.9261 19.1159 18.9244 19.1313 18.9236 19.1467C19.2197 18.9806 19.4911 18.7769 19.7325 18.5415C19.5262 18.6614 19.2874 18.7315 19.0323 18.7315H18.9261Z"
      fill="currentColor"
    />
    <path
      d="M14.2234 16.8775H13.3169C13.5437 17.6376 13.9974 18.301 14.6008 18.7863H17.0284C15.7556 18.7863 14.6659 17.9937 14.2234 16.8775Z"
      fill="currentColor"
    />
    <path
      d="M17.0199 11.8974C17.0746 12.1062 17.12 12.3194 17.1517 12.5359H14.8979C14.2679 12.952 13.7663 13.546 13.4658 14.2479H14.4245C14.9492 13.3543 15.9191 12.7534 17.0276 12.7534C17.7449 12.7534 18.4048 13.0059 18.9227 13.4253C18.9227 13.4142 18.9244 13.4031 18.9244 13.3919C18.9244 13.0401 18.8996 12.6934 18.8534 12.3545C18.309 12.0626 17.6875 11.8974 17.0276 11.8974C17.025 11.8974 17.0216 11.8974 17.019 11.8974H17.0199Z"
      fill="currentColor"
    />
    <path
      d="M20.4292 16.5668C20.4292 16.1927 20.2811 15.8537 20.0406 15.6021C20.044 15.6577 20.0457 15.7134 20.0457 15.7698C20.0457 17.3714 18.7917 18.6845 17.2142 18.7803V18.7863H14.6017C15.2659 19.3213 16.1099 19.6423 17.0293 19.6423C17.7175 19.6423 18.3637 19.4617 18.9244 19.1467C18.9244 19.1313 18.927 19.1159 18.927 19.1005V18.7315H19.0331C19.2882 18.7315 19.527 18.6614 19.7333 18.5415C19.9824 18.2984 20.1981 18.0228 20.3744 17.7206C20.4095 17.5974 20.4301 17.4681 20.4301 17.3337V16.5659L20.4292 16.5668Z"
      fill="currentColor"
    />
    <path
      d="M14.0119 15.7698C14.0119 15.5627 14.0333 15.3607 14.0727 15.1655H13.203C13.1722 15.3624 13.156 15.5636 13.156 15.7698C13.156 16.155 13.2133 16.5265 13.3177 16.8766H14.2242C14.0881 16.5342 14.0128 16.1602 14.0128 15.7698H14.0119Z"
      fill="currentColor"
    />
    <path
      d="M17.0284 17.6907C16.5559 17.6907 16.1724 17.3072 16.1724 16.8347V14.3849C16.1724 13.9124 16.5559 13.5289 17.0284 13.5289C17.5009 13.5289 17.8844 13.9124 17.8844 14.3849V16.8347C17.8844 17.3072 17.5009 17.6907 17.0284 17.6907Z"
      fill="currentColor"
    />
    <path
      d="M18.2533 16.4666H15.8035C15.331 16.4666 14.9475 16.0831 14.9475 15.6106C14.9475 15.1381 15.331 14.7546 15.8035 14.7546H18.2533C18.7258 14.7546 19.1093 15.1381 19.1093 15.6106C19.1093 16.0831 18.7258 16.4666 18.2533 16.4666Z"
      fill="currentColor"
    />
  </svg>
</template>
